<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_schedule_start_date') || '计划开始日期'"
            prop="scheduleStartDate"
          >
            <el-date-picker
              size="mini"
              style="width:100%"
              value-format="yyyy-MM-dd"
              clearable
              v-model="formData.scheduleStartDate"
              :picker-options="scheduleStartDatePicker"
              type="date"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_schedule_end_date') || '计划结束日期'"
            prop="scheduleEndDate"
          >
            <el-date-picker
              size="mini"
              style="width:100%"
              value-format="yyyy-MM-dd"
              clearable
              v-model="formData.scheduleEndDate"
              :picker-options="scheduleEndDatePicker"
              type="date"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('table_label_departure_city_name') || '出差起始地'"
            prop="departureCityCode"
          >
            <dict-select
              v-model="formData.departureCityCode"
              url="/master/common/dict/biz"
              :body="tripCityParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              style="width: 100%"
              filterable
              clearable
              :selectedLabel.sync="formData.departureCityName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('table_label_destination_city_name') || '出差目的地'"
            prop="destinationCityCode"
          >
            <dict-select
              v-model="formData.destinationCityCode"
              url="/master/common/dict/biz"
              :body="tripCityParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              style="width: 100%"
              filterable
              clearable
              :selectedLabel.sync="formData.destinationCityName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('table_label_trip_type') || '出差目的'"
            prop="tripType"
          >
            <dict-select
              v-model="formData.tripType"
              url="/master/common/dict/biz"
              :body="tripTypeParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              filterable
              size="mini"
              style="width:100%"
              :selectedLabel.sync="formData.v_tripType"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.table_label_custName') || '客户'"
            prop="custCode"
          >
            <dict-select
              clearable
              v-model="formData.custCode"
              filterable
              url="/master/common/dict/customerSelect"
              size="mini"
              style="width:100%"
              :selectedLabel.sync="formData.custName"
              @change="changeCustAndOrder"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('table_label_scm') || '供应商'"
            prop="scmCode"
          >
            <dict-select
              :placeholder="
                $l('form_label_please_select_scmName') || '请选择供应商'
              "
              size="mini"
              clearable
              filterable
              v-model="formData.scmCode"
              url="/master/common/dict/allScmCooperated"
              :selectedLabel.sync="formData.scmName"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_customerOrderNo') || '客户订单号'"
          >
            <el-select
              v-model="formData.custAndOrderList"
              filterable
              clearable
              multiple
              size="mini"
              style="width:100%"
              :disabled="orderDisabled"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            >
              <el-option
                v-for="item in optionData"
                :key="item.value"
                :label="item.label"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_tripPurpose') || '预计解决问题'"
            prop="tripPurpose"
          >
            <el-input
              v-model="formData.tripPurpose"
              :placeholder="
                $l('form_label_please_enter_the_tripPurpose') ||
                  '请输入预计解决问题'
              "
              clearable
              type="textarea"
              rows="5"
              maxlength="500"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import { request } from '@/api/service'
export default {
  components: {},
  props: {
    disabled: { type: Boolean, default: false },
    userTripRequestCode: { type: String, default: '' },
    userTripRequestScheduleCode: { type: String, default: '' },
    form: { type: Object, default: () => {} },
    type: { type: String, default: '' },
    tripStartDate: { type: String, default: '' },
    tripEndDate: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      rules: {
        scheduleStartDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        scheduleEndDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        departureCityCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        destinationCityCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        tripType: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        tripPurpose: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
      tripCityParams: { dictType: 'tripCity' },
      scmParams: { dictType: 'tripType' },
      tripTypeParams: { dictType: 'purposeOfTrip' },
      optionData: [],
      orderDisabled: true,
      scheduleStartDatePicker: this.scheduleEndDate(),
      scheduleEndDatePicker: this.scheduleStartDate(),
    }
  },
  watch: {
    form: {
      handler() {
        this.getData()
      },
      immediate: true,
    },
  },
  methods: {
    getData() {
      if (this.isExpand && this.type !== 'add') {
        this.$api
          .userTripRequestScheduleDetailApi({
            userTripRequestCode: this.form.userTripRequestCode,
            userTripRequestScheduleCode: this.form.userTripRequestScheduleCode,
          })
          .then((res) => {
            this.formData = res.body
            if (this.formData.custCode) {
              this.orderDisabled = false
              this.loadData(this.formData.custCode)
            }
          })
        return
      }
      if (this.type && this.type !== 'add') {
        this.formData = { ...this.form }
        if (this.formData.custCode) {
          this.orderDisabled = false
          this.loadData(this.formData.custCode)
        }
        return
      }
      this.formData.uuid = this.form.uuid
    },
    async loadData(custCode) {
      const res = await request({
        url: '/factory/orderInfo/select',
        data: { custCode },
        method: 'POST',
      })
      if (res.body.data) {
        this.optionData = res.body.data.map((m) => {
          return { value: m.orderCode, label: m.custOrderNo }
        })
      }
    },
    changeCustAndOrder() {
      const custCode = this.formData.custCode
      if (custCode) {
        this.loadData(custCode)
        this.orderDisabled = false
      } else {
        this.orderDisabled = true
      }
      this.formData.custAndOrderList = []
    },

    async getForm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      return this.formData
    },
    scheduleStartDate() {
      const self = this
      const tripStartDate = new Date(self.tripStartDate).getTime()
      const tripEndDate = new Date(self.tripEndDate).getTime()
      return {
        disabledDate(time) {
          if (self.formData.scheduleStartDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              (new Date(self.formData.scheduleStartDate).getTime() -
                3600 * 1000 * 24 >
                time.getTime()) |
              (tripStartDate - 3600 * 1000 * 24 > time.getTime()) |
              (tripEndDate < time.getTime())
            )
          } else {
            return (
              (tripStartDate - 3600 * 1000 * 24 > time.getTime()) |
              (tripEndDate < time.getTime())
            )
          }
        },
      }
    },
    scheduleEndDate() {
      const self = this
      const tripStartDate = new Date(self.tripStartDate).getTime()
      const tripEndDate = new Date(self.tripEndDate).getTime()
      return {
        disabledDate(time) {
          if (self.formData.scheduleEndDate) {
            //如果结束时间不为空，则小于结束时间
            return (
              (new Date(self.formData.scheduleEndDate).getTime() <
                time.getTime()) |
              (tripEndDate < time.getTime()) |
              (tripStartDate - 3600 * 1000 * 24 > time.getTime())
            )
          } else {
            return (
              (tripEndDate < time.getTime()) |
              (tripStartDate - 3600 * 1000 * 24 > time.getTime())
            )
          }
        },
      }
    },
  },
}
</script>
